import React, { useState } from 'react';
import Header from 'components/widgets/Header';
import InputSearch from 'components/widgets/InputSearch';
import {
    makeStyles, useTheme, useMediaQuery, RadioGroup, FormControlLabel, Radio,
} from '@material-ui/core';
import AccountingStyles from 'styles/modules/accounting/AccountingStyles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import LabelValue from 'components/widgets/LabelValue';
import DatePicker from 'react-datepicker';
import Select from 'components/widgets/Select';
import CalendarContainer from 'components/widgets/form/CalendarContainer';
import { JournalTypes, ShowJournalType } from 'utils/enum/AccountingEnum';
import DateUtils from 'lib/DateUtils';

const useStyle = makeStyles((theme) => AccountingStyles.mainList(theme));

const HeaderJournalCommon = (props) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const classes = useStyle();

    const {
        journalType, setParameters, totalCount,
        showPostedRangeColumn, rangeColumns,
    } = props;

    const isJournalTypeInventory = journalType === JournalTypes.INVENTORY;

    const initState = {
        search: '',
        radioOption: isJournalTypeInventory ? ShowJournalType.SHOW_NO_POSTED_ACTIVE : ShowJournalType.SHOW_NO_POSTED,
        fromDate: new Date(DateUtils.subtractAndFormatUTC(new Date(), 1, 'months')),
        toDate: new Date(),
    };
    const [params, setParams] = useState(initState);

    const {
        search,
        radioOption,
        fromDate,
        toDate,
    } = params;

    const onSetParams = (name, value) => {
        const currentParams = {
            ...params,
            [name]: value,
        };

        setParams(currentParams);

        setParameters(currentParams);
    };

    return (
        <Header>
            <div className={clsx(classes.containerFilterSearch, isMobile ? classes.searchFull : '')}>
                <InputSearch
                    customClasses={clsx(classes.search, isMobile ? classes.searchFull : '')}
                    initialSearch={search || ''}
                    onSearch={(val) => onSetParams('search', val)}
                />
                <RadioGroup row value={radioOption} onChange={(e, val) => onSetParams('radioOption', val)}>
                    {isJournalTypeInventory
                    && (
                        <FormControlLabel
                            value={ShowJournalType.SHOW_NO_POSTED_ACTIVE}
                            control={<Radio color="primary" />}
                            label="No Posted (Active)"
                        />
                    )}
                    <FormControlLabel
                        value={ShowJournalType.SHOW_NO_POSTED}
                        control={<Radio color="primary" />}
                        label="Not Posted (All)"
                    />
                    <FormControlLabel
                        value={ShowJournalType.SHOW_POSTED}
                        control={<Radio color="primary" />}
                        label="Posted between"
                    />
                </RadioGroup>
                {radioOption === ShowJournalType.SHOW_POSTED && (
                    <>
                        <Select
                            size="sm"
                            loading={false}
                            className={classes.input}
                            name="showPostedRangeColumn"
                            onChange={(name, value) => onSetParams(name, value)}
                            value={showPostedRangeColumn}
                            options={Object.values(rangeColumns).map((c) => {
                                let label = c;
                                if (label === rangeColumns.RO_CLOSED) label = 'Closed Date';
                                if (label === rangeColumns.TICKET_OPEN) label = 'Opened Date';

                                return {
                                    value: c,
                                    label,
                                };
                            })}
                        />
                        <DatePicker
                            popperContainer={CalendarContainer}
                            className={clsx('form-control form-control-sm', classes.date, isMobile ? classes.dateInRange : '')}
                            selected={fromDate || new Date()}
                            maxDate={toDate}
                            onChange={(val) => onSetParams('fromDate', val)}
                            placeholderText="mm/dd/yyyy"
                        />
                        <DatePicker
                            popperContainer={CalendarContainer}
                            className={clsx('form-control form-control-sm', classes.date, isMobile ? classes.dateInRange : '')}
                            selected={toDate || new Date()}
                            // minDate={useDateRange ? fromDate : null}
                            minDate={fromDate}
                            onChange={(val) => onSetParams('toDate', val)}
                            placeholderText="mm/dd/yyyy"
                        />
                    </>
                )}
                <LabelValue
                    label="Items"
                    value={totalCount}
                />
            </div>
        </Header>
    );
};

HeaderJournalCommon.propTypes = {
    journalType: PropTypes.string.isRequired,
    setParameters: PropTypes.func.isRequired,
    totalCount: PropTypes.number,
    showPostedRangeColumn: PropTypes.string.isRequired,
    rangeColumns: PropTypes.object.isRequired,
};

HeaderJournalCommon.defaultProps = {
    totalCount: 0,
};

export default HeaderJournalCommon;
